import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../user1000Aside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIInputPW from 'components/input/inputPW';
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
import userRepository from "common/user/repository/UserRepository";
import userStore from "common/user/store/UserStore";
import ValidationUtil from "../../../../common/validation/util/ValidationUtil";

function ContentsContainer() {
    const location = useLocation();
    const receivedData = (location.state as any)?.data;
    const history = useHistory();
    const [loginPassword ,setLoginPassword] = useState('');
    const [confirmPassword ,setConfirmPassword] = useState('');
    const [chgPassword ,setChgPassword] = useState('');
    const loginForm = React.useRef<HTMLFormElement>(null);
    const [errorCode, setErrorCode] = React.useState<string>("");


    const formId = "loginForm";

    async function onClickSave(event) {
        if(ValidationUtil.checkAll()) return;
        console.log(loginForm.current);

        if(loginPassword == "" || chgPassword == "" || confirmPassword == ""){
            await UIUtils.alert('비밀번호를 입력해주세요.');
            return;
        }

//         if(await UIUtils.confirm('저장하시겠습니까?')){

            const response:any = await CommonUtil.execute({
                url: "usr_1502.jct",
                form: loginForm.current as HTMLFormElement,
            }).then((response: any) => {
                // if(response.ERR_CD =="9999") {
                //     UIUtils.alert(response.ERR_MSG).then();
                //     return;
                // } else {
                    // 변경 완료 후 로그아웃
                    UIUtils.alert('비밀번호 변경이 완료되었습니다. \n 다시 로그인해 주세요.')
                    .then(() => {
                        userStore.logoutQuietly(false)
                    });
                // }
            }).catch((error) => {
                CommonUtil.showAxiosError(error);
                return;
            });
//         }

    };

    const onClickPage = () => {
        history.push({
            pathname: '/main',
        });
    }

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="/main/usr_1000/usr_1500">마이페이지</Link></li>
					<li><Link to="#">비밀번호 수정</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<div className="mypage pw-edit">
						<h1 className="tx tx-hd2">비밀번호 수정</h1>
						<div className="sub-tx">비밀번호를 새롭게 설정해 주세요.</div>
						<form className="fo fo-col2" id={formId} name={formId} ref={loginForm}>
							<div className="inner">
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">사용중이던 비밀번호를 입력</p>
									<div className="fo-value">
                                    <UIInputPW
                                        className={'tf tf-md w385'}
                                        placeholder={'비밀번호를 입력하세요'}
                                        attrs={{
                                            name: "LOGIN_PASSWORD",
                                            alt: "Password",
                                            tabIndex: 1,
                                            autoComplete: "on",
                                        }}
                                        readOnly={false}
                                        valueChanged={(value) => setLoginPassword(value)}
                                        rules={["required"]}
                                        focusClear={true}
                                    />
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
								    <p className="fo-key">새로운 비밀번호를 입력</p>
									<div className="fo-value">
                                    <UIInputPW
                                        className={'tf tf-md w385'}
                                        placeholder={'새로운 비밀번호를 입력하세요'}
                                        attrs={{
                                            name: "CHG_PASSWORD",
                                            alt: "Password",
                                            tabIndex: 2,
                                            autoComplete: "on",
                                        }}
                                        readOnly={false}
                                        valueChanged={(value) => setChgPassword(value)}
                                        rules={["required","password"]}
                                        focusClear={true}
                                    />
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
								    <p className="fo-key">비밀번호를 한번 더 입력</p>
									<div className="fo-value">
										<div>
										    <UIInputPW
                                                className={'tf tf-md w385'}
                                                placeholder={'비밀번호를 한번 더 입력하세요'}
                                                attrs={{
                                                    name: "CONFIRM_PASSWORD",
                                                    alt: "Password",
                                                    tabIndex: 3,
                                                    autoComplete: "on",
                                                }}
                                                readOnly={false}
                                                valueChanged={(value) => setConfirmPassword(value)}
                                                rules={["required","password"]}
                                                focusClear={true}
                                            />
											<p className="tx-msg mt8">※ 8~12자의 영문, 숫자, 특수문자 조합으로 입력해 주세요.</p>
										</div>
									</div>
								</div>
							</div>
						</form>
						<div className="hz-root hz-center hz-gap10">
							<Button color='gray-o' size="big" onClick={onClickPage}>취소</Button>
							<Button color='pri' size="big" onClick={onClickSave}>저장</Button>
						</div>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;